export default "__VITE_ASSET__BLJ0_TtJ__"